"use client";

import { useSearchParams } from "next/navigation";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { OverviewAnalysisTab } from "../data/overview-analysis-tabs";

export const Select = ({ tabs }: { tabs: OverviewAnalysisTab[] }) => {
  const searchParams = useSearchParams();
  const { updateQuery } = useUpdateQuery();
  const tabKey = searchParams.get("overview") ?? tabs[0].key;
  return (
    <div className="flex items-center gap-2.5 @2xl:hidden">
      <select
        id="tabs"
        name="tabs"
        aria-label="select overview"
        className="block w-full rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600"
        onChange={(e) => {
          const tabKey = tabs[e.target.selectedIndex].key;
          updateQuery({ name: "overview", value: tabKey });
        }}
        defaultValue={tabs.find((tab) => tab.key === tabKey)?.name}
      >
        {tabs.map((tab) => (
          <option
            key={tab.key}
            aria-label={`view ${tab.key} summaries`}
            aria-selected={tab.key === tabKey}
          >
            {tab.name}
          </option>
        ))}
      </select>
    </div>
  );
};
